import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import Alert from './components/Alert/AlertDialog';
import Login from './pages/Login';
import PrivateLayout from './components/layout/PrivateLayout';
import ProtectedRoute from './components/protected-route/ProtectedRoute';
import { OrganizationFilterProvider } from './contexts/OrganizationFilterContext';

const App = () => {
    return (
        <OrganizationFilterProvider>
            <Routes>
                <Route path="login" element={<Login />} />
                <Route path="login/:id" element={<Login />} />
                <Route path="login-simp/:id" element={<Login theme="green" />} />
                <Route path="login-backoffice/:id" element={<Login theme="green" />} />
                <Route
                    path="/*"
                    element={
                        <ProtectedRoute rol="viewer">
                            <PrivateLayout />
                        </ProtectedRoute>
                    }
                />
                <Route path="*" element={<p>There's nothing here: 404!</p>} />{' '}
                {/* <Route path="*" element={<Navigate replace to="/" />} /> */}
            </Routes>
            <Alert />
        </OrganizationFilterProvider>
    );
};

export default App;
